import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyNumValidation {

  constructor() { }

  static ValidatePowerSupplyNum = (region: string) => {
    return (control: AbstractControl) => {
      if (control.value !== ''
        && control.value !== null
        && control.value !== undefined) {
        if (region === 'Boston Region' && (control.value.length > 5 || control.value.length < 3))
          return { validatePSNum: true }
      }
      return null;
    }
  }


  static ValidateacInputVoltage = (inputVoltageRatings: string[]) => {
      return (control: AbstractControl) => {
          if (inputVoltageRatings.indexOf(control.value) > -1) {
              return null;
          } else {
              return {validateacInputVoltage: true};
          }
      }
  }

  static ValidateacOutputVoltage = (outVoltageRatings: string[]) => {
    return (control: AbstractControl) => {
        if (outVoltageRatings.indexOf(control.value) > -1) {
            return null;
        }else{
            return { validateacOutputVoltage: true };
        }
    }

  }

  static ValidatecurrentAmp = (ampRatings: string[]) => {
    return (control: AbstractControl) => {
      if (ampRatings.indexOf(control.value) > -1) {
        return null;
      }else{
          return { validatecurrentAmp: true };
      }

    }
  }

  static ValidatecurrentAmpOutput = () => {
    return (control: AbstractControl) => {
      if ((control.value == 'Output#1' || control.value == 'Output#2' || control.value == 'DualOutput')) {
        return null;
      }
      if ((control.value != 'Output#1' || control.value != 'Output#2' || control.value != 'DualOutput')) {
        return { validatecurrentAmpOutput: true }
      }
    }
  }
}
